"use strict";

var _interopRequireDefault3 = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault3(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault3(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault3(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault3(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault3(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault3(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault3(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault3(require("@babel/runtime/helpers/defineProperty"));

var _interopRequireDefault2 = _interopRequireDefault3(require("@babel/runtime/helpers/interopRequireDefault"));

var _autobindDecorator = _interopRequireDefault3(require("autobind-decorator"));

var _Button = _interopRequireDefault3(require("../../Button"));

var _classnames = _interopRequireDefault3(require("classnames"));

var _icon = require("../../utils/icon");

var _convertUnsafeMethod = _interopRequireDefault3(require("../../utils/convertUnsafeMethod"));

var _createId = _interopRequireDefault3(require("../../utils/createId"));

var _CrossSmall = _interopRequireDefault3(require("../../Icon/core/CrossSmall"));

var _Magnifier = _interopRequireDefault3(require("../../Icon/core/Magnifier"));

var _intl = require("../../utils/intl");

var _propTypes = _interopRequireDefault3(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _Textfield = _interopRequireDefault3(require("../../Textfield"));

var _class, _class2, _temp;

var intlMessages = {
  "cs-CZ": (0, _interopRequireDefault2["default"])(require("./../intl/cs-CZ.json"))["default"],
  "da-DK": (0, _interopRequireDefault2["default"])(require("./../intl/da-DK.json"))["default"],
  "de-DE": (0, _interopRequireDefault2["default"])(require("./../intl/de-DE.json"))["default"],
  "en-US": (0, _interopRequireDefault2["default"])(require("./../intl/en-US.json"))["default"],
  "es-ES": (0, _interopRequireDefault2["default"])(require("./../intl/es-ES.json"))["default"],
  "fi-FI": (0, _interopRequireDefault2["default"])(require("./../intl/fi-FI.json"))["default"],
  "fr-FR": (0, _interopRequireDefault2["default"])(require("./../intl/fr-FR.json"))["default"],
  "hu-HU": (0, _interopRequireDefault2["default"])(require("./../intl/hu-HU.json"))["default"],
  "it-IT": (0, _interopRequireDefault2["default"])(require("./../intl/it-IT.json"))["default"],
  "ja-JP": (0, _interopRequireDefault2["default"])(require("./../intl/ja-JP.json"))["default"],
  "ko-KR": (0, _interopRequireDefault2["default"])(require("./../intl/ko-KR.json"))["default"],
  "nb-NO": (0, _interopRequireDefault2["default"])(require("./../intl/nb-NO.json"))["default"],
  "nl-NL": (0, _interopRequireDefault2["default"])(require("./../intl/nl-NL.json"))["default"],
  "pl-PL": (0, _interopRequireDefault2["default"])(require("./../intl/pl-PL.json"))["default"],
  "pt-BR": (0, _interopRequireDefault2["default"])(require("./../intl/pt-BR.json"))["default"],
  "ru-RU": (0, _interopRequireDefault2["default"])(require("./../intl/ru-RU.json"))["default"],
  "sv-SE": (0, _interopRequireDefault2["default"])(require("./../intl/sv-SE.json"))["default"],
  "tr-TR": (0, _interopRequireDefault2["default"])(require("./../intl/tr-TR.json"))["default"],
  "uk-UA": (0, _interopRequireDefault2["default"])(require("./../intl/uk-UA.json"))["default"],
  "zh-CN": (0, _interopRequireDefault2["default"])(require("./../intl/zh-CN.json"))["default"],
  "zh-TW": (0, _interopRequireDefault2["default"])(require("./../intl/zh-TW.json"))["default"]
};

if (process.env.SCALE_MEDIUM && process.env.SCALE_LARGE) {
  require("../../spectrum-css/search/index.css");

  require("../../spectrum-css/search/index-diff.css");
} else if (process.env.SCALE_LARGE) {
  require("../../spectrum-css/search/index-lg.css");
} else {
  require("../../spectrum-css/search/index.css");
}

if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_LIGHT) require("../../spectrum-css/search/multiStops/light.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_DARK) require("../../spectrum-css/search/multiStops/dark.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_LIGHTEST) require("../../spectrum-css/search/multiStops/lightest.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_DARKEST) require("../../spectrum-css/search/multiStops/darkest.css");
var formatMessage = (0, _intl.messageFormatter)(intlMessages);

var normalizeValue = function normalizeValue(value) {
  return value || '';
};

var Search = (0, _convertUnsafeMethod["default"])(_class = (0, _autobindDecorator["default"])(_class = (_temp = _class2 =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Search, _Component);

  function Search(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Search);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Search).call(this, props));
    _this.searchId = (0, _createId["default"])();
    var value = props.value,
        defaultValue = props.defaultValue;
    _this.state = {
      value: normalizeValue(value || defaultValue)
    };
    return _this;
  }

  (0, _createClass2["default"])(Search, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(props) {
      if (normalizeValue(props.value) !== this.state.value) {
        this.setState({
          value: props.value
        });
      }
    }
  }, {
    key: "handleTextKeyDown",
    value: function handleTextKeyDown(e) {
      var _this$props = this.props,
          onSubmit = _this$props.onSubmit,
          onKeyDown = _this$props.onKeyDown,
          disabled = _this$props.disabled;
      var value = this.state.value;
      var key = e.which;

      if (key === 13 || key === 27) {
        e.preventDefault();
      }

      if (disabled) {
        return;
      }

      if (key === 13) {
        onSubmit(value);
      }

      if (key === 27) {
        this.handleTextChange('', e, 'escapeKey');
      }

      if (onKeyDown) {
        onKeyDown(e);
      }
    }
  }, {
    key: "handleTextChange",
    value: function handleTextChange(value, e) {
      var from = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'input';
      var _this$props2 = this.props,
          onChange = _this$props2.onChange,
          disabled = _this$props2.disabled;

      if (disabled || value === this.state.value) {
        return;
      }

      if (!('value' in this.props)) {
        this.setState({
          value: value
        });
      }

      onChange(value, e, {
        from: from
      });
    }
  }, {
    key: "handleClearButtonClick",
    value: function handleClearButtonClick(e) {
      this.handleTextChange('', e, 'clearButton'); // restore focus to the searchbox

      if (this.searchbox) {
        this.searchbox.focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          disabled = _this$props3.disabled,
          className = _this$props3.className,
          icon = _this$props3.icon,
          _this$props3$id = _this$props3.id,
          id = _this$props3$id === void 0 ? this.searchId : _this$props3$id,
          otherProps = (0, _objectWithoutProperties2["default"])(_this$props3, ["disabled", "className", "icon", "id"]);
      var value = this.state.value;
      return _react["default"].createElement("div", {
        className: (0, _classnames["default"])('spectrum-Search', {
          'is-disabled': disabled
        }, className)
      }, _react["default"].createElement(_Textfield["default"], (0, _extends2["default"])({
        type: "search",
        ref: function ref(s) {
          return _this2.searchbox = s;
        },
        className: "spectrum-Search-input",
        value: value,
        disabled: disabled,
        id: id
      }, otherProps, {
        onKeyDown: this.handleTextKeyDown,
        onChange: this.handleTextChange
      })), (0, _icon.cloneIcon)(icon, {
        className: 'spectrum-Search-icon',
        size: 'S'
      }), value !== '' && _react["default"].createElement(_Button["default"], {
        "aria-label": formatMessage('Clear search'),
        "aria-labelledby": "".concat(id, " ").concat(id, "-clear-button"),
        variant: "clear",
        icon: _react["default"].createElement(_CrossSmall["default"], null),
        id: "".concat(id, "-clear-button"),
        disabled: disabled,
        onClick: this.handleClearButtonClick
      }));
    }
  }]);
  return Search;
}(_react.Component), (0, _defineProperty2["default"])(_class2, "propTypes", {
  /** Sets the search field value (controlled). */
  value: _propTypes["default"].string,

  /** Sets the default search field value (uncontrolled). */
  defaultValue: _propTypes["default"].string,

  /** Sets the icon displayed in the search field. Magnifier icon by default. */
  icon: _propTypes["default"].node
}), (0, _defineProperty2["default"])(_class2, "defaultProps", {
  icon: _react["default"].createElement(_Magnifier["default"], null),
  onChange: function onChange() {},
  onSubmit: function onSubmit() {}
}), _temp)) || _class) || _class;

exports["default"] = Search;
Search.displayName = 'Search';